var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /** @format */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ShowIf from "../../App/ShowIf";
import { Icon } from "../../UI";

export class ShowSidepanelMenu extends Component {
  render() {
    const { panelIsOpen, openPanel, active } = this.props;
    return (/*#__PURE__*/
      _jsx("div", { className: active ? 'active' : '' }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: !panelIsOpen }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn btn-primary", onClick: (e) => openPanel(e) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "columns" })
      )
      )
      ));

  }
}

ShowSidepanelMenu.defaultProps = {
  active: false
};